let errorMessageTitle: string = '';
let errorMessageDescription: string = '';
let errorMessagePhoneNumber: string = '';
let errorMessagePhoneNumberInfo: string = '';
let errorMessageButtonText: string = '';
let errorMessageNotAllDataCanBeRetrieved: string = '';

export class ErrorMessageService {
    public static setErrorMessagePropertes(
        title: string,
        description: string,
        phoneNumber: string,
        phoneNumberInfo: string,
        buttonText: string,
        notAllDataCanBeRetrieved: string
    ) {
        errorMessageTitle = title;
        errorMessageDescription = description;
        errorMessagePhoneNumber = phoneNumber;
        errorMessagePhoneNumberInfo = phoneNumberInfo;
        errorMessageButtonText = buttonText;

        errorMessageNotAllDataCanBeRetrieved = notAllDataCanBeRetrieved;
    }

    public static errorMessageTitle() {
        return errorMessageTitle;
    }

    public static errorMessageDescription(errorObject?: any) {
        if (errorObject && errorObject.Title) {
            return `${errorObject.Title}
<br><br>
         ${errorMessageDescription}
         `;
        }

        return errorMessageDescription;
    }

    public static errorMessagePhoneNumber() {
        return errorMessagePhoneNumber;
    }

    public static errorMessagePhoneNumberInfo() {
        return errorMessagePhoneNumberInfo;
    }

    public static errorMessageButtonText() {
        return errorMessageButtonText;
    }

    public static errorMessageNotAllDataCanBeRetrieved() {
        return errorMessageNotAllDataCanBeRetrieved;
    }
}
